import {Appliance} from 'components/customer/Product/Appliance/entity/Appliance';
import {mode} from 'components/customer/Product/Appliance/helpers/mode';
import {RANGEHOOD} from 'components/customer/Product/store/productApi';
import {setApplianceOpeningHeight} from 'components/customer/Product/store/productSlice';
import {AppApi} from 'store/customer/api';

interface Rangehood {
    make: string;
    model: string;
    code: string;
    height: number;
}

export const ApplianceApi = AppApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAppliances: builder.query<Appliance[], void>({
            query: () => 'customer/rangehoods',
            transformResponse: (response: {data: Rangehood[]}) => {
                return response.data.map((item) => ({
                    type: RANGEHOOD,
                    custom: false,
                    externalCode: item.code,
                    make: item.make,
                    model: item.model,
                    specPath: null,
                    height: item.height,
                }));
            },
            onQueryStarted: async (_args, {dispatch, queryFulfilled}) => {
                try {
                    const {data} = await queryFulfilled;

                    const average = mode(
                        data
                            .map((item) => item.height)
                            .filter((num) => num != undefined)
                    );

                    dispatch(setApplianceOpeningHeight(average));
                } catch {
                    // may be log something later
                }
            },
            providesTags: ['RangeHoods'],
        }),
    }),
});

export const {useFetchAppliancesQuery} = ApplianceApi;
